import FlexBox from '@/atomic-components/FlexBox';
import { Box, IconButton } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import InfoIconSvg from '@/assets/pdp/informationIcon.svg';
import ArrowWithoutTail from '@/assets/ArrowWithoutTail';
import { getColor } from '@/utils/theme/colors';

import { formatPrice } from '@/utils/common';
type TCartSummaryLineItemProps = {
	title: string;
	subTitle: string;
	amount: string;
	Icon: any;
	upfrontOffer?: any;
	onInfoClicked: () => void;
	selectedTenure?: any;
	onTenureClicked?: () => void;
};

const CartSummaryLineItem = (props: TCartSummaryLineItemProps) => {
	const tenureSelectorvisible = props.upfrontOffer?.paymentPlans;
	const showEmptyState =
		!tenureSelectorvisible ||
		(Array.isArray(tenureSelectorvisible) &&
			tenureSelectorvisible.length === 0);

	const split = formatPrice(props.amount);

	return (
		<Box>
			<FlexBox
				direction='row'
				justifyContent={'space-between'}
				alignItems='center'
			>
				<FlexBox alignItems={'center'}>
					<props.Icon />
					<LencoTypography ml='8px' mr='16px' variant='P_Medium'>
						{props.title}
					</LencoTypography>
					{props?.selectedTenure && !showEmptyState && (
						<LencoTypography
							onClick={props?.onTenureClicked}
							variant='Tiny_Regular'
							color={getColor('Gray 0')}
							sx={{
								border: `1px solid ${getColor('Minty 0')}`,
								padding: '6px 16px',
								borderRadius: '16px',
								cursor: 'pointer',
							}}
						>
							{props?.selectedTenure < 2
								? `Monthly`
								: `${props.selectedTenure} Months`}{' '}
							<span style={{ marginLeft: '4px' }}>
								<ArrowWithoutTail
									color={getColor('Gray 0')}
									height={8}
									width={12}
								/>
							</span>
						</LencoTypography>
					)}
				</FlexBox>
				<FlexBox alignItems='center'>
					<LencoTypography variant='P_SemiBold' mr='8px'>
						<FlexBox alignItems='baseline' sx={{ whiteSpace: 'nowrap' }}>
							{Array.isArray(split) && (
								<>
									₹{split[0]}
									<LencoTypography
										component='span'
										sx={{ fontSize: '10px', fontWeight: 400 }}
									>
										.{split[1]}
									</LencoTypography>
								</>
							)}
						</FlexBox>
					</LencoTypography>
					<IconButton onClick={props.onInfoClicked}>
						<InfoIconSvg />
					</IconButton>
				</FlexBox>
			</FlexBox>
		</Box>
	);
};

export default CartSummaryLineItem;
